import { SvgIcon } from "@mui/material";
import React from "react";

function DoctorsIcon(props) {
  return (
    <SvgIcon viewBox="0 0 22 22" {...props}>
      <path
        d="M16.9584 17.875H13.2917"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.125 19.7096V16.043"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1466 9.96286C11.055 9.9537 10.945 9.9537 10.8441 9.96286C8.66247 9.88953 6.92997 8.10203 6.92997 5.90203C6.9208 3.6562 8.74497 1.83203 10.9908 1.83203C13.2366 1.83203 15.0608 3.6562 15.0608 5.90203C15.0608 8.10203 13.3191 9.88953 11.1466 9.96286Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9909 19.9929C9.32254 19.9929 7.66337 19.5712 6.39837 18.7279C4.18004 17.2429 4.18004 14.8229 6.39837 13.347C8.9192 11.6604 13.0534 11.6604 15.5742 13.347"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default DoctorsIcon;
